const PORTAL_TIME_ZONE = "America/Sao_Paulo";

export function portalTodayKey(now = new Date()) {
  return now.toLocaleDateString("sv-SE", { timeZone: PORTAL_TIME_ZONE });
}

export function portalTicketDayKey(value) {
  if (!value) return "";
  const normalized = String(value).trim();
  if (/^\d{4}-\d{2}-\d{2}$/.test(normalized)) return normalized;
  const timestamp = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(normalized)
    ? `${normalized.replace(" ", "T")}Z`
    : normalized;
  const date = new Date(timestamp);
  return Number.isNaN(date.getTime())
    ? ""
    : date.toLocaleDateString("sv-SE", { timeZone: PORTAL_TIME_ZONE });
}
